import { render, staticRenderFns } from "./EditUserPhoneModal.vue?vue&type=template&id=00b4da74"
import script from "./EditUserPhoneModal.vue?vue&type=script&lang=js"
export * from "./EditUserPhoneModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports